<template>
  <div style="display: flex;flex-direction: column">
    <a
      class="top-banner"
      @click="goToPage()"
    >
      <div class="top-banner__wrapper">
        <div class="top-banner__text">
          <div class="top-banner__title">US & EU local production is here!</div>
          <div class="top-banner__subtitle">Skip the customs and wait—just smooth fulfillment to help you grow!
          </div>
        </div>
        <div class="top-banner__flag">
          <img src="../assets/europe_1.png" alt="Europe flag">
        </div>
      </div>
    </a>
    <header style=" height: 72px;">
      <div
        class="container"
        @click="delProductValue()"
        :style="{
          ...ulStyle,
        }"
        :class="{
          'is-fixed': isFixed,
          'header-hide': isHeaderHide,
          'header-show': isHeaderShow,
          'no-transition': isScrollUp
        }"
      >
        <div class="logo_view">
          <img src="../assets/icon/logo.png" alt="logo" @click="toHome">
        </div>
        <a-menu v-model="current" mode="horizontal" style="margin-left: 70px">
          <a-menu-item key="1" @click="goPageURL({key: 1, label: '/products/category/all-products'})"
                       :class="{'item_name': true, 'active': $route.path.startsWith('/products')}">
            <span @mouseenter="(e) => mouseenter(e,'products')" @mouseleave="(e)=>mouseleave(e,'products')">
              Products <a-icon type="down"/>
              <div style="position: absolute; top: 0px; left: 0px; width: 100%;">
                <div>
                  <transition name="products-fade">
                    <div class="ant-dropdown ant-dropdown-placement-bottomCenter" style="left: -378px; top: 33px;"
                         v-show="show">
                      <div class="product-modal-item ant-dropdown-content"
                           @mouseenter="(e) => mouseenter(e,'products')"
                           @mouseleave="(e)=>mouseleave(e,'products')"
                           @click.stop>
                        <a-row>
                          <a-col span="7" class="product-modal-menu">
                            <ul role="menu" class="ant-menu ant-menu-inline ant-menu-root ant-menu-light"
                                v-if="tagsList && tagsList.length > 0">
                              <li v-for="(tag) in tagsList" :key="tag.id" role="menuitem"
                                  :class="'ant-menu-submenu ant-menu-submenu-inline ' + (selectKey === tag.id ? 'ant-menu-item-selected' : '')">
                                <div class="ant-menu-submenu-title" style="padding-left: 24px;">
                                  <div
                                    style="font-size: 17px;font-weight: bold; width: 90%; overflow-y: hidden; text-overflow: ellipsis;"
                                    @click="clickMenu($event, tag.id)">{{ tag.name }}</div><i
                                  class="header-product-menu-arrow"></i>
                                </div>
                              </li>
                            </ul>
                            <a-divider></a-divider>
                            <ul role="menu" class="ant-menu ant-menu-inline ant-menu-root ant-menu-light"
                                v-if="menuData && menuData.length > 0">
                              <li v-for="(menu) in menuData" :key="menu.id" role="menuitem"
                                  :class="'ant-menu-submenu ant-menu-submenu-inline ' + (selectKey === menu.id ? 'ant-menu-item-selected' : '')">
                                <div class="ant-menu-submenu-title" style="padding-left: 24px;">
                                  <div
                                    style="font-size: 17px;font-weight: bold; width: 90%; overflow-y: hidden; text-overflow: ellipsis;"
                                    @click="clickMenu($event, menu.id)">{{ menu.name }}</div><i
                                  class="header-product-menu-arrow"></i>
                                </div>
                              </li>
                            </ul>
                          </a-col>
                          <a-col span="17" class="product-modal-content product_box">
                            <div style="padding: 0px 7px 0px 7px;">
                              <a-row v-if="selectType === 0">
                                <a-col span="20" style="font-size: 20px;color: #333282;">{{ selectTitle }}</a-col>
                                <a-col span="4" style="font-size: 16px;text-align:right;"><a style="color: #333282;"
                                                                                             @click="toMore">More <a-icon
                                  type="right"/></a></a-col>
                              </a-row>
                              <a-row class="product_view" v-if="selectType === 0">
                                <a-skeleton :loading="spinning" active :paragraph="{rows: 14}">
                                  <div class="product_list" v-if="dataList.length>0">
                                    <div class="list_box" v-for="(item,index) in dataList" :key="index"
                                         @click="toDetailsDes(item)">
                                      <div class="img_box">
                                        <img class="img1" :src="item.productImg|imgFilter(360)">
                                        <img class="img2" :src="item.productTemplateImg|imgFilter(360)">
                                      </div>
                                      <span class="name" :title="item.productNameEn">{{ item.productNameEn }}</span>
                                      <span class="price">Start from $ {{ item.minPrice }}</span>
                                      <span class="price" style="margin-top: 12px;margin-bottom: 12px;"
                                            :title="item.spec">{{ item.spec }}
                                      </span>
                                    </div>
                                  </div>
                                  <div class="empty_box" v-else>
                                    <img src="../assets/empty.png">
                                  </div>
                                </a-skeleton>
                              </a-row>
                              <a-row v-if="selectType === 1">
                                <ul style="column-count:3;line-height: 2.5">
                                  <li v-for="(menu) in selectMenuData" :key="menu.id"
                                      style="font-size: 16px;margin-bottom: 10px;">
                                    <a
                                      style="color: #666666;font-size: 18px;font-family: HarmonyOS Sans SC;font-weight: 600;"
                                      @click="toProducts(menu.id)">{{ menu.name }}</a>
                                    <ul v-if="menu.children.length > 1" style="font-size: 16px;color: #485256;">
                                      <li v-for="(third) in menu.children" :key="third.id" style="font-weight: 400;">
                                        <a style="color: #111111;" @click="toProducts(third.id)">{{ third.name }}<span
                                          v-if="false" class="new">New</span></a>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </a-row>
                              <a-row v-if="selectType === 1" style="position: absolute; bottom: 12px; right: 132px;">
                                <a-col span="20" style="font-size: 20px;color: #333282;"></a-col>
                                <a-col span="4"
                                       style="font-size: 16px;text-align:right;font-family: HarmonyOS Sans SC;font-weight: 400;"><a
                                  style="color: #333282;" @click="toMore">View All Products <a-icon
                                  type="right"/></a></a-col>
                              </a-row>
                            </div>
                            <div class="title_box">
                              <div
                                class="des-wrapper"
                                @click="goPageURL({key: 1, label: '/products/category/all-products'})"
                                @mouseenter="isHovered = true"
                                @mouseleave="isHovered = false"
                              >
                                <span class="des" :class="{ 'des-hover': isHovered }">
                                  Explore
                                  <img class="img" src="../assets/right-arrow.png" :class="{ 'img-hover': isHovered }"/>
                                </span>
                              </div>
                            </div>
                          </a-col>
                        </a-row>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </span>
          </a-menu-item>
          <a-menu-item key="5" @click="goPageURL({key: 5, label: '/integrations'})"
                       :class="{'item_name': true, 'active': $route.path.startsWith('/integrations')}"
                       style="margin-right: 3px">
            <span @mouseenter="(e) => mouseenter(e,'integrations')"
                  @mouseleave="(e)=>mouseleave(e,'integrations')">
              Integrations
              <a-icon type="down"/>
              <div style="position: absolute; top: 0px; left: 0px; width: 100%;">
                <div>
                  <transition name="dropdown-expand">
                    <div class="ant-dropdown ant-dropdown-placement-bottomCenter dropdown-container"
                         style="left: 2px; top: 33px;"
                         v-if="show1">
                      <div class="integrations-wrapper"
                           @mouseenter="(e) => mouseenter(e,'integrations')"
                           @mouseleave="(e)=>mouseleave(e,'integrations')"
                           @click.stop>
                        <a v-for="item in integrationItems"
                           :key="item.name"
                           :href="item.url"
                           class="integration-item"
                           target="_blank">
                          {{ item.name }}
                        </a>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </span>
          </a-menu-item>
          <a-menu-item key="2" @click="goPageURL({key: 2, label: '/about'})"
                       :class="{'item_name': true, 'active': $route.path === '/about'}"
                       style="margin-right: 10px">About Us
          </a-menu-item>
          <a-menu-item key="6" @click="goPageURL({key: 6, label: '/blog/us'})"
                       :class="{'item_name': true, 'active': $route.path === '/blog/us'}"
                       style="margin-right: 6px">Blog
          </a-menu-item>
          <a-menu-item key="3" @click="goPageURL({key: 3, label: '/help'})"
                       :class="{'item_name': true, 'active': $route.path === '/help'}"
                       style="margin-right: 6px">Help
          </a-menu-item>
          <a-menu-item key="4" @click="goPageURL({key: 4, label: '/faqs'})"
                       :class="{'item_name': true, 'active': $route.path === '/faqs'}"
                       style="margin-right: 9px">FAQs
          </a-menu-item>
        </a-menu>
        <div class="right_view">
          <div class="search_view" :class="{ active: showSearch }" @click="handleSearchIconClick">
            <img class="search1" src="../assets/icon/search1.png" alt="logo">
          </div>
          <a-button type="primary" ghost @click="toSignIn" class="sign_in">
            Log in
          </a-button>
          <a-button type="primary" class="sign_up" @click="toSignUp">
            Sign up
          </a-button>
        </div>

        <transition name="search-fade">
          <div class="search_box" v-show="showSearch" @click.stop>
            <div class="search-input-wrapper">
              <a-input
                size="large"
                ref="searchInput"
                v-model="localProductName"
                placeholder="Search Products"
                class="search-input"
                @click.stop
                allow-clear
                @focus="inputFocused = true"
                @blur="inputFocused = false"
                @search="onSearch"
                @change="searchProductList"
                :class="{ 'search-input-focused': inputFocused }"
                :style="inputStyle"
              >
                <img slot="prefix" src="../assets/icon/search.png" alt="logo">
                <img slot="clearIcon" src="../assets/icon/clear.png" alt="logo">
              </a-input>
            </div>
            <div v-if="localProductName">
              <div v-if="searchList.length>0">
                <a-skeleton class="search_items" :loading="spinning1" active :paragraph="{rows: 19}">
                  <div>
                    <div class="wrapper_items">
                      <div v-for="(item, index) in searchList" :key="index" @click="toDetailsDes(item)">
                        <div class="list_items">
                          <img :src="item.productImg|imgFilter(200)">
                          <div>
                            <span class="name" :title="item.productNameEn">{{ item.productNameEn }}</span>
                            <span class="price">Start from $ {{ item.minPrice }}</span>
                            <span class="price" style="margin-top: 2px" :title="item.spec">
                              {{ item.spec }}
                            </span>
                          </div>
                        </div>
                        <div class="divider"></div>
                      </div>
                    </div>
                  </div>
                </a-skeleton>
                <div class="show_more">
                  <span style="cursor: pointer" @click="onSearch(undefined)">View all {{ total }} products</span>
                  <img src="../assets/arrow.png" style="margin-left: 3px">
                </div>
              </div>
              <div v-else-if="!spinning1" class="empty">
                We could not find any matches for '{{ localProductName }}'.
                <br>
                Please check your spelling or try another search term.
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div class="service_chat">
        <div class="service_list">
          <a class="chat_item chat_skype" target="_blank" ref="nofollow" title="Click to MsTeams"
             href="msteams://teams.microsoft.com/l/chat/0/0?users=luojiao@printbelle.com"></a>
          <a-popover overlayClassName="recharge-custom-popover" placement="left">
            <div class="chat_item chat_wechat" title="Wechat">
            </div>
            <template slot="content">
              <img src="../assets/service_wechat.png" style="width: 150px;height: 150px;">
            </template>
          </a-popover>
          <a-popover overlayClassName="recharge-custom-popover" placement="left">
            <div class="chat_lark" title="Lark"></div>
            <template slot="content">
              <img src="../assets/service_lark.png" style="width: 150px;height: 150px;">
            </template>
          </a-popover>
        </div>
        <!-- 隐藏时也占位，避免图标堆叠跳动 -->
        <div class="back-top-wrap">
          <a-back-top :visibility-height="0"/>
        </div>
      </div>
    </header>
  </div>

</template>

<script>
import EventBus from '../router/event-bus.js'
import {get, post} from '@/api'
import {getSeoLinkName, loadCustomScript, loadGTM} from '@/utils/utils'

export default {
  name: 'Header',
  props: {
    routeValue: {
      type: String
    },
    productName: {
      type: String,
      default: ''
    },
    ulStyle: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      isScrollUp: false,
      lastScrollTop: 0,
      isHeaderHide: false,
      isHeaderShow: false,
      scrollTimer: null,
      isHeaderSticky: false, // 控制header吸顶
      isHeaderSlide: false,  // 控制header向下展开动画
      isSearchHovered: false,
      showSearch: false,
      inputFocused: false,
      show: false,
      show1: false,
      isHovered: false,
      productValue: undefined,
      localProductName: this.productName,
      spinning: true,
      spinning1: false,
      total: 0,
      tagsList: [],
      searchList: [],
      menuData: [],
      webAnalytics: new Map(),
      expandedMenuName: new Map(),
      selectMenuData: [],
      selectType: 0,
      selectTitle: '',
      selectKey: '',
      dataList: [],
      current: [],
      queryParam: {
        pageNum: 1,
        pageSize: 6,
        categoryId: undefined,
        orderByType: undefined,
        tagIds: []
      },
      isFixed: false,
      integrationItems: [
        {name: 'Printbelle API', url: 'https://documenter.getpostman.com/view/25923095/2s93RL1vvB'},
        {name: 'Customily', url: 'https://app.customily.com/stamp/printbelle'},
        {name: 'Shopify', url: 'https://apps.shopify.com/printbelle-print-on-demand'},
        {name: 'Teeinblue', url: 'https://teeinblue.com/pages/printbelle'},
        {name: 'Order Desk', url: 'https://www.orderdesk.com/integrations/printbelle'},
        {name: 'DodgePrint', url: 'https://dodgeprint.com/vi/integrations/printbelle'},
      ]
    }
  },
  computed: {
    inputStyle: function () {
      var hasContent = this.localProductName && this.localProductName.trim()
      return {
        width: hasContent ? '894px' : '505px',
        transition: 'width 0.3s ease-in-out'
      }
    }
  },
  mounted: function () {
    this.getWebAnalytics()
    this.initScrollListener()
    this.initDocumentClickListener()
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('click', this.handleDocumentClick)
    //清除定时器
    if (this.scrollTimer) clearTimeout(this.scrollTimer)
  },
  created: function () {
    this.getTagsList()
    this.getCategoryList()
  },
  watch: {
    productName: {
      handler: function (val) {
        this.localProductName = val
        if (val && String(val).trim() && !this.searchList.length) {
          this.searchProductList()
        }
      },
      immediate: true
    },
    selectKey: function (val) {
      if (this.selectType === 0) {
        this.queryParam.tagIds = [val]
        this.getProductList()
      }
    }
  },
  methods: {
    handleSearchIconClick: function (e) {
      e.stopPropagation()
      this.showSearch = !this.showSearch
      this.delProductValue()

      this.$nextTick(function () {
        if (this.showSearch && this.$refs.searchInput) {
          this.$refs.searchInput.focus()
        }
      }.bind(this))
    },
    closeSearchBox: function () {
      this.showSearch = false
      this.delProductValue()
    },
    handleScroll: function () {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop
      if (this.lastScrollTop <= 70 && currentScroll > 70) {
        this.isHeaderHide = true
        setTimeout(() => {
          this.isHeaderShow = true
        }, 80)
      }
      if (currentScroll < this.lastScrollTop) {
        this.isHeaderHide = false
        this.isHeaderShow = false
      }
      this.isFixed = currentScroll >= 70
      this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll
    },
    initScrollListener: function () {
      window.addEventListener('scroll', this.handleScroll)
      this.handleScroll()
    },
    handleDocumentClick: function (e) {
      var isSearchClick = e.target.closest('.search_box') || e.target.closest('.search_view')
      if (!isSearchClick) {
        this.closeSearchBox()
        this.show = false
        this.show1 = false
      }
    },
    initDocumentClickListener: function () {
      document.addEventListener('click', this.handleDocumentClick)
    },
    searchProductList: function () {
      var productName = this.localProductName ? this.localProductName.trim() : ''
      EventBus.$emit('customEvent', productName || '', 0)
      this.spinning1 = true

      post('/index/product/search', {
        pageNum: 1,
        pageSize: 16,
        productName: productName
      }).then(function (res) {
        this.spinning1 = false
        this.searchList = res.data.list
        this.total = res.data.total
        this.formatSpec(this.searchList)
      }.bind(this)).catch(function () {
        this.spinning1 = false
      }.bind(this))
    },
    goPageURL: function (item) {
      this.show = false
      this.showSearch = false
      if (item.key === 1) {
        EventBus.$emit('customEvent', undefined, 2)
      }
      if (this.$route.path !== item.label) {
        this.$router.push(item.label)
      }
    },
    goToPage: function () {
      window.location.href = `/products/category/all-products?tab=other&value=us-de`
    },
    onSearch: function (value) {
      this.delProductValue()
      this.showSearch = false
      var productName = this.localProductName
      EventBus.$emit('customEvent', productName, 1)
      var targetPath = '/products/category/all-products'
      if (this.$route.path !== targetPath) {
        var query = {tab: 'cn'}
        if (productName) {
          query.productName = productName
        }
        // 用 path + 手工编码，空格为 %20 而非 +
        var qs = Object.keys(query).map(function (key) {
          return encodeURIComponent(key) + '=' + encodeURIComponent(query[key])
        }).join('&')
        this.$router.push(targetPath + '?' + qs)
      }
    },
    toSignIn: function () {
      window.open(process.env.VUE_APP_MERCHANT, '_blank')
    },
    toSignUp: function () {
      window.open(process.env.VUE_APP_MERCHANT + 'user/register', '_blank')
    },
    toHome: function () {
      this.current = []
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    },
    getTagsList: function () {
      get('/index/product/tags').then(function (res) {
        if (res.data && res.data.children && res.data.children.length) {
          this.tagsList = res.data.children
          this.selectType = 0
          this.selectTitle = this.tagsList[0].name
          this.selectKey = this.tagsList[0].id
          EventBus.$emit('productTagsLoaded', this.tagsList)
        }
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    getCategoryList: function () {
      get('/index/product/category').then(function (res) {
        if (res.data && res.data.children) {
          this.menuData = res.data.children
          this.buildExpandedMenuName()
        }
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    buildExpandedMenuName: function () {
      var self = this
      this.menuData.forEach(function (l1) {
        self.expandedMenuName.set(l1.id, [getSeoLinkName(l1.name)])
        if (l1.children) {
          l1.children.forEach(function (l2) {
            self.expandedMenuName.set(l2.id, [getSeoLinkName(l1.name), getSeoLinkName(l2.name)])
            if (l2.children) {
              l2.children.forEach(function (l3) {
                self.expandedMenuName.set(l3.id, [
                  getSeoLinkName(l1.name),
                  getSeoLinkName(l2.name),
                  getSeoLinkName(l3.name)
                ])
              })
            }
          })
        }
      })
    },
    getWebAnalytics: function () {
      get('/index/webAnalytics').then(function (res) {
        this.webAnalytics = res.data
        this.loadAnalyticsScripts()
      }.bind(this)).catch(function (err) {
        console.error(err)
      })
    },
    loadAnalyticsScripts: function () {
      var self = this
      if (this.webAnalytics && this.webAnalytics[0]) {
        this.webAnalytics[0].forEach(function (item) {
          if (item.content) {
            item.pixId = self.getGAMeasurementIdFromCode(item.content)
            loadGTM(item.pixId)
            window.dataLayer = window.dataLayer || []
            var gtag = function () {
              window.dataLayer.push(arguments)
            }
            gtag('js', new Date())
            gtag('config', item.pixId)
          }
        })
      }
      if (this.webAnalytics && this.webAnalytics[1]) {
        this.webAnalytics[1].forEach(function (item) {
          if (item.content) {
            loadCustomScript(item.content)
          }
        })
      }
      if (this.webAnalytics && this.webAnalytics[2]) {
        this.webAnalytics[2].forEach(function (item) {
          loadCustomScript('' +
            '<script type="text/javascript">' +
            '!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=\'2.0\';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,\'script\',\'https://connect.facebook.net/en_US/fbevents.js\');' +
            'fbq(\'init\', \'' + item.pixId + '\', {}, {\'agent\':\'printbelle\'});' +
            'fbq(\'init\', \'' + item.accessToken + '\', {}, {\'agent\':\'printbelle\'});' +
            'fbq(\'track\', "PageView");' +
            '<\/script>' +
            '<noscript><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=' + item.pixId + '&ev=PageView&noscript=1" /></noscript>')
        })
      }
    },
    getGAMeasurementIdFromCode: function (code) {
      var match = code.match(/id=([^"']+)["']/)
      return match && match[1] ? match[1] : null
    },
    mouseenter: function (e, type) {
      e.preventDefault()
      this.showSearch = false
      var index = type === 'products' ? 0 : 1
      var targetShow = type === 'products' ? 'show' : 'show1'
      var arrows = document.getElementsByClassName('anticon-down')
      if (arrows && arrows[index]) {
        arrows[index].style.transform = 'rotate(-180deg)'
      }
      this[targetShow] = true
    },
    mouseleave: function (e, type) {
      e.preventDefault()
      var index = type === 'products' ? 0 : 1
      var targetShow = type === 'products' ? 'show' : 'show1'
      var arrows = document.getElementsByClassName('anticon-down')
      if (arrows && arrows[index]) {
        arrows[index].style.transform = 'unset'
      }
      this[targetShow] = false
    },
    delProductValue: function () {
      this.productValue = undefined
    },
    clickMenu: function (e, key) {
      e.stopPropagation()
      var tag = null
      for (var i = 0; i < this.tagsList.length; i++) {
        if (this.tagsList[i].id === key) {
          tag = this.tagsList[i]
          break
        }
      }
      if (tag) {
        this.selectType = 0
        this.selectTitle = tag.name
        this.selectKey = tag.id
        return
      }
      var menu = null
      for (var j = 0; j < this.menuData.length; j++) {
        if (this.menuData[j].id === key) {
          menu = this.menuData[j]
          break
        }
      }
      if (menu) {
        this.selectType = 1
        this.selectTitle = menu.name
        this.selectKey = menu.id
        this.selectMenuData = menu.children
      }
    },
    formatSpec: function (list) {
      list.forEach(function (item) {
        var specColorOptionVOS = item.specColorOptionVOS || []
        var specOptionsVOS = item.specOptionsVOS || []
        var spec = specColorOptionVOS.map(function (i) {
          return i.colorOptionVOList.length + ' ' + i.specsName
        }).join(' ')
        var spec1 = specOptionsVOS.map(function (i) {
          return i.optionNames.length + ' ' + i.specsName
        }).join(' ')
        item.spec = spec + '   ' + spec1
      })
    },
    getProductList: function () {
      this.spinning = true
      post('/index/product/search', this.queryParam).then(function (res) {
        this.dataList = res.data.list
        this.dataList.forEach(function (item) {
          item.productTemplateImg = item.productTemplateImg || item.productImg
        })
        this.formatSpec(this.dataList)
        this.spinning = false
      }.bind(this)).catch(function () {
        this.spinning = false
      }.bind(this))
    },
    toDetailsDes: function (item) {
      window.open('/products/' + item.seoCustomerAddress, '_blank')
    },
    toMore: function () {
      if (this.selectType === 0) {
        window.location.href = '/products/category/tagId=' + this.selectKey
        return
      }
      var names = this.expandedMenuName.get(this.selectKey)
      if (!names) names = []
      window.location.href = '/products/category/' + names.join('/')
    },
    toProducts: function (id) {
      if (this.selectType === 0) {
        window.location.href = '/products/category/tagId=' + id
        return
      }
      var names = this.expandedMenuName.get(id)
      if (!names) names = []
      window.location.href = '/products/category/' + names.join('/')
    }
  }
}
</script>

<style lang="less" src="../assets/css/font.scss"></style>

<style lang="less" src="../assets/css/font.scss"></style>

<style lang="less">
// 全局搜索框聚焦样式
.search-input .ant-input:focus {
  border-color: #C5FAFF !important;
  box-shadow: 0 0 0 3px rgba(197, 250, 255, 0.5) !important;
  outline: none !important;
}
</style>

<style scoped lang="less">
// ====================== 动画变量 ======================
@fade-transition: all 0.2s ease;
@expand-transition: all 0.2s cubic-bezier(0.25, 0.1, 0.25, 1);
@hover-scale-time: 0.3s;

// ====================== 公共动画 ======================
.search-fade-enter-active,
.search-fade-leave-active {
  transition: @fade-transition;
}

.search-fade-enter {
  opacity: 0;
  transform: translateY(-6px);
}

.search-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.products-fade-enter-active,
.products-fade-leave-active {
  transition: all 0.3s ease;
}

.products-fade-enter {
  opacity: 0;
  transform: translateY(-6px);
}

.products-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

.dropdown-expand-enter-active {
  transition: @expand-transition;
  overflow: hidden;
}

.dropdown-expand-leave-active {
  transition: all 0.1s cubic-bezier(0.4, 0, 0.6, 1);
  overflow: hidden;
}

.dropdown-expand-enter,
.dropdown-expand-leave-to {
  opacity: 0;
  transform: translateY(-10px);
  max-height: 0;
}

.dropdown-expand-enter-to,
.dropdown-expand-leave {
  opacity: 1;
  transform: translateY(0);
  max-height: 200px;
}


// ====================== 搜索弹窗 ======================
.search_box {
  font-family: HarmonyOS Sans SC;
  z-index: 9999;
  position: absolute;
  left: 50%;
  top: 72px;
  transform: translateX(-50%) translateZ(0);
  width: 970px;
  max-width: calc(100% - 40px);
  background: #fff;
  border-radius: 0 0 12px 12px;
  box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  backface-visibility: hidden;
  perspective: 1000px;


  .search-input-wrapper {
    display: flex;
    justify-content: center;
    padding: 26px 0;
  }

  .search-input {
    width: 505px;
    transition: width 0.3s ease;
  }

  /deep/ .ant-input-lg {
    height: 45px;
    line-height: 46px;
  }

  /deep/ .search-input .ant-input {
    padding-left: 40px !important;
  }

  /deep/ .search-input .ant-input-clear-icon {
    font-size: 0 !important;
    background: url("../assets/icon/clear.png") no-repeat center !important;
    width: 12px !important;
    height: 12px !important;
    cursor: pointer !important;
  }

  // 滚动条样式（保留不变）
  ::-webkit-scrollbar {
    width: 3px;
  }

  ::-webkit-scrollbar-thumb {
    background: #343183;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .empty {
    padding: 10px 0 30px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
  }

  .show_more {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 15px 0;
    text-align: center;
    background: #fff;
    border-radius: 0 0 12px 12px;
    font-size: 16px;
    color: #012169;
  }

  .search_items {
    height: 620px;
    padding: 0 12px;
    margin: 0 45px 55px 0;
    overflow-y: auto;

    .wrapper_items {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
    }

    .list_items {
      display: flex;
      padding: 12px 20px;
      cursor: pointer;
      border-radius: 8px;

      &:hover {
        background: #F8FAFC;
      }

      img {
        width: 91px;
        height: 91px;
        object-fit: cover;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
      }

      .name, .price {
        margin: 0 13px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }

      .name {
        -webkit-line-clamp: 2;
        font-size: 16px;
        font-weight: 500;
        color: #111;
        line-height: 1.4;
        height: 2.8em;
      }

      .price {
        -webkit-line-clamp: 1;
        font-size: 15px;
        font-weight: 300;
        color: #111;
      }
    }
  }
}

.container.no-transition {
  transition: none !important;
  top: 0 !important;
}

.container {
  position: relative;
  top: auto !important;
  z-index: 200;
  width: 100%;
  height: 72px;
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #d2d2d2;
  box-shadow: 0 10px 10px rgba(1, 1, 1, 0.05);
  font-family: HarmonyOS Sans SC;
  transition: all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1) !important;

  &.is-fixed {
    position: fixed;
    top: 0 !important;
    left: 0;
  }

  &.header-hide {
    top: -72px !important;
    transform: none !important;
  }

  &.header-show {
    top: 0 !important;
    transform: none !important;
  }

  .logo_view {
    margin-left: 16.35%;
    cursor: pointer;
  }

  .right_view {
    display: flex;
    align-items: center;

    .search_view {
      width: 40px;
      height: 40px;
      line-height: 40px;
      margin-top: -3px;
      text-align: center;
      border-radius: 5px;
      margin-right: 75px;
      cursor: pointer;
      background: #fff;
      transition: background 0.2s;

      &:hover, &.active {
        background: #EBFDFF !important;
      }

      .search1 {
        width: 16px;
        height: 16px;
      }
    }
  }

  .item_name {
    font-size: 18px;
    font-weight: bold;
    color: #111;

    &:hover, &.active {
      color: #012169;
    }
  }

  .sign_in, .sign_up {
    width: 105px;
    height: 40px;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
  }

  .sign_in {
    border: 1px solid #c2c2c2;
    background: #fff;
    color: #111;
  }

  .sign_up {
    margin-left: 10px;
    border: 1px solid #C5FAFF;
    background: #C5FAFF;
    color: #111;
  }
}

// ====================== 顶部横幅 ======================
.top-banner.banner-hide {
  transform: translateY(-100%);
  visibility: hidden;
}

.top-banner.banner-hide {
  transform: translateY(-100%);
  visibility: hidden;
}

.top-banner {
  display: block;
  padding: 8px 0;
  background: #C5FAFF;
  text-decoration: none;
  transition: all 0.3s ease !important;
  opacity: 1;
  visibility: visible;

  .top-banner__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 1280px;
    margin: 0 auto 0 310px;
    position: relative;
  }

  .top-banner__text {
    text-align: center;
  }

  .top-banner__title {
    font-size: 24px;
    font-weight: bold;
    color: #012169;
  }

  .top-banner__subtitle {
    font-size: 14px;
    color: #012169;
  }

  .top-banner__flag {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 114px;
    height: 53px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

// ====================== 右侧客服 ======================
.service_chat {
  position: fixed;
  right: 50px;
  bottom: 135px;
  z-index: 150;

  .chat_item {
    display: block;
    position: relative;
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background: url(../assets/icon_chat.png) no-repeat 0 0;
    margin-bottom: 6px;
  }

  .chat_skype {
    cursor: pointer;
    background: #f0f0fa url(../assets/ms_teams.png) no-repeat center / 70% 70%;
  }

  .chat_wechat {
    background-color: #59c682;
    background-position: 0 -200px;
  }

  .chat_lark {
    display: block;
    position: relative;
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background-image: url(../assets/icon_lark.svg);
    border: 1px solid #ccdfff;
    background-color: white;
    background-size: 100% 100%;
    margin-bottom: 6px;
  }
}

// ====================== 产品下拉面板 ======================
.product-modal-item {
  width: 870px;
  margin-top: 15px;
  background: #fff;
  border-radius: 0 0 15px 15px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.15);
}

.product-modal-menu,
.product-modal-content {
  height: 710px;
  padding: 16px;
  font-size: 16px;
  font-weight: bold;
  border: 1px solid #ddd;
}

.product-modal-menu {
  border-radius: 0 0 0 15px;
}

.product-modal-content {
  position: relative;
  border-left: none;
  border-radius: 0 0 15px 0;
}

.anticon-down {
  transition: transform 0.33s;
}

// ====================== 集成菜单 ======================
.integrations-wrapper {
  width: 167px;
  margin-top: 15px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 5px 7px rgba(0, 0, 0, 0.2);
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  gap: 3px;

  .integration-item {
    height: 37px;
    padding-left: 15px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    text-decoration: none;
    transition: background 0.3s;

    &:hover {
      background: #E2FCFF;
      color: #000;
    }
  }
}

// ====================== 产品卡片 ======================
.title_box {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 20px;
  display: flex;
  justify-content: center;
  z-index: 10;

  .des-wrapper {
    cursor: pointer;
  }

  .des {
    display: inline-flex;
    align-items: center;
    font-size: 17px;
    color: #111;
    transition: transform 0.6s;
  }

  .img {
    width: 16px;
    height: 14px;
    margin-left: 3px;
    transition: transform 0.6s;
  }

  .des-hover {
    transform: translateX(-4px);
  }

  .img-hover {
    transform: translateX(6px);
  }
}

// ====================== 产品列表 ======================
/deep/ .product_box {
  .product_view {
    .empty_box {
      margin-top: 7%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .product_list {
      display: flex;
      flex-wrap: wrap;
      gap: 18px;
      margin-bottom: 20px;
      margin-top: 10px;

      .list_box {
        width: 177px;
        height: 280px;
        background: #fff;
        border: 1px solid #DFE1E6;
        border-radius: 4px;
        cursor: pointer;

        .img_box {
          width: 140px;
          height: 140px;
          margin: 12px auto 0;
          border-radius: 3px;
          overflow: hidden;
          position: relative;
        }

        .img1, .img2 {
          width: 100%;
          height: 100%;
          position: absolute;
          border-radius: 3px;
          transition: all @hover-scale-time;
        }

        .img1 {
          opacity: 1;
        }

        .img2 {
          opacity: 0;
        }

        &:hover {
          .img1 {
            opacity: 0;
            transform: scale(1.1);
          }

          .img2 {
            opacity: 1;
            transform: scale(1.1);
          }
        }

        .name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          margin: 10px 13px;
          font-weight: 500;
          font-size: 14px;
          color: #111111;
          line-height: 1.4em;
        }

        .price {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          margin: 0 13px;
          font-weight: 400;
          font-size: 14px;
          color: #666666;
        }
      }
    }
  }

  .new {
    margin-left: 6px;
    padding: 0 6px;
    background: #FFE0C5;
    border: 1px solid #F6790F;
    border-radius: 3px;
    font-size: 14px;
    color: #F6923D;
  }
}

// ====================== 菜单箭头样式 ======================

/deep/ .ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left {
  border-right: none;
}

/deep/ .header-product-menu-arrow::before,
/deep/ .header-product-menu-arrow::after {
  position: absolute;
  width: 8px;
  height: 1.5px;
  content: '';
  background: rgba(0, 0, 0, 0.65);
  border-radius: 2px;
  transition: background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), top 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

/deep/ .ant-menu-inline-collapsed .header-product-menu-arrow,
/deep/ .ant-menu-submenu-inline .header-product-menu-arrow {
  position: absolute;
  top: 50%;
  right: 16px;
  width: 10px;
  height: 1.5px;
}

/deep/ .ant-menu-inline-collapsed .header-product-menu-arrow::before,
/deep/ .ant-menu-submenu-inline .header-product-menu-arrow::before {
  transform: rotate(-45deg) translateX(-3.6px);
}

/deep/ .ant-menu-inline-collapsed .header-product-menu-arrow::after,
/deep/ .ant-menu-submenu-inline .header-product-menu-arrow::after {
  transform: rotate(45deg) translateX(-3.6px);
}

/deep/ .ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .header-product-menu-arrow::before {
  transform: rotate(45deg) translateX(3.6px);
}

/deep/ .ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title > .header-product-menu-arrow::after {
  transform: rotate(-45deg) translateX(-3.6px);
}

/deep/ .ant-menu-item .anticon, .ant-menu-submenu-title .anticon {
  margin-right: 2px;
}

// ====================== 返回顶部 ======================
// 固定 50x50 槽位：按钮隐藏时也占位，与客服图标垂直对齐
.back-top-wrap {
  position: relative;
  width: 50px;
  height: 50px;
}

/deep/ .ant-back-top {
  position: absolute !important;
  right: 0;
  bottom: 0;
  width: 50px;
  height: 50px;
}

/deep/ .ant-back-top-content {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

/deep/ .ant-back-top-icon {
  margin: 13px auto;
  width: 20px;
  height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue